import { queryOptions } from "@tanstack/react-query";
import {
  adminGetCase,
  adminGetCases,
  adminGetSites,
  getFullmaktStatus,
  getOrders,
} from "./api";

// One queryOptions factory per server resource — used by route loaders
// (ensureQueryData) and components (useQuery) so both share the same cache key.

export const adminCasesQuery = (params?: { status?: string; q?: string }) =>
  queryOptions({
    queryKey: ["admin", "cases", { status: params?.status, q: params?.q }],
    queryFn: () => adminGetCases(params),
  });

export const adminCaseQuery = (id: string) =>
  queryOptions({
    queryKey: ["admin", "case", id],
    queryFn: () => adminGetCase(id),
  });

export const adminSitesQuery = () =>
  queryOptions({
    queryKey: ["admin", "sites"],
    queryFn: adminGetSites,
  });

export const ordersQuery = () =>
  queryOptions({
    queryKey: ["orders"],
    queryFn: getOrders,
  });

export const fullmaktQuery = () =>
  queryOptions({
    queryKey: ["fullmakt"],
    queryFn: getFullmaktStatus,
  });
